<template>
  <div class="home-container">
    <header class="header">
      <nav class="nav">
        <router-link to="/home/map" class="nav-item" active-class="active">
          <span>首页</span>
          <span class="tibetan">གཙོ་ངོས།</span>
        </router-link>
        <router-link to="/home/map" class="nav-item" active-class="active">
          <span>地图</span>
          <span class="tibetan">ས་བཀྲ།</span>
        </router-link>
        <router-link to="/home/vr-mask" class="nav-item" active-class="active">
          <span>VR脸谱</span>
          <span class="tibetan">VR འབག།</span>
        </router-link>
        <router-link to="/home/dubbing" class="nav-item" active-class="active">
          <span>趣配音</span>
          <span class="tibetan">སྒྲ་སྦྱོར།</span>
        </router-link>
        <router-link to="/home/community" class="nav-item" active-class="active">
          <span>社交互动</span>
          <span class="tibetan">སྤྱོད་འབྲེལ།</span>
        </router-link>
      </nav>
      <div class="user-info">
        <div class="welcome-text">
          <span>欢迎，{{ userStore.userInfo?.username || '游客' }}</span>
          <span class="tibetan">བསུ་བ།</span>
        </div>
        <el-button type="danger" size="small" @click="handleLogout">退出<span class="btn-tibetan">ཕྱིར་འཐོན།</span></el-button>
      </div>
    </header>
    
    <main class="main-content">
      <router-view />
    </main>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'
import { useUserStore } from '@/store/user'
import { ElMessageBox } from 'element-plus'

const router = useRouter()
const userStore = useUserStore()

const handleLogout = () => {
  ElMessageBox.confirm('确定要退出登录吗？', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    userStore.logout()
    router.push('/login')
  }).catch(() => {})
}
</script>

<style scoped lang="scss">
.home-container {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
}

.header {
  background: linear-gradient(135deg, #8B4513 0%, #D2691E 100%);
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  
  .nav {
    display: flex;
    gap: 10px;
    
    .nav-item {
      padding: 14px 30px;
      color: white;
      text-decoration: none;
      font-size: 18px;
      font-weight: 500;
      transition: all 0.3s;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 1.2;

      .tibetan {
        font-size: 14px;
        opacity: 0.75;
        font-weight: 400;
        margin-top: 2px;
      }
      
      &:hover {
        background: rgba(255, 255, 255, 0.1);
      }
      
      &.active {
        background: rgba(255, 255, 255, 0.2);
        color: #FFD700;
        
        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 60%;
          height: 3px;
          background: #FFD700;
        }
      }
    }
  }
  
  .user-info {
    display: flex;
    align-items: center;
    gap: 15px;
    color: white;
    font-size: 14px;

    .welcome-text {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      line-height: 1.3;

      .tibetan {
        font-size: 12px;
        opacity: 0.75;
      }
    }

    .btn-tibetan {
      margin-left: 4px;
      font-size: 12px;
      opacity: 0.8;
    }
  }
}

.main-content {
  padding: 20px;
  min-height: calc(100vh - 70px);
}
</style>
